import { safeFetch } from "../utils/safeFetch";

export const restoreCongressInvoiceAccount = async (id, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${id}/restore-congress-account`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  if (!response.ok) {
    let message = `HTTP error! status: ${response.status}`;
    try {
      const body = await response.json();
      message = body?.error || body?.message || message;
    } catch {
      const body = await response.text();
      if (body) message = body;
    }
    throw new Error(message);
  }
  return response.json();
};

export const createInvoice = async (payload, token, tenant) => {
  const response = await safeFetch(`/api/invoices`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  return response.json();
};

export const getAllInvoices = async (token, tenant) => {
  const response = await safeFetch(`/api/invoices`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  return response.json();
};

export const generateInvoiceXML = async (invoice_id, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${invoice_id}/xml`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  console.log("response", response)

  return response.text();//.json();
};

export const updateInvoice = async (id, data, token, tenant) => {
  console.log("Id: ", id)
  const response = await safeFetch(`/api/invoices/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(data),
  });

  if (!response || !response.ok) {
    if (response?.status === 404) {
      throw new Error('Fattura non trovata');
    }
    throw new Error(`HTTP error! status: ${response?.status}`);
  }

  return await response.json();
};

export const getInvoicePayments = async (id, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${id}/payments`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export const createInvoicePayment = async (id, payload, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${id}/payments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export const sendInvoiceBatch = async (invoiceIds, token, tenant) => {
  const response = await safeFetch(`/api/invoices/send-batch`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify({ invoiceIds }),
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  return response.json();
};

export const cancelInvoice = async (id, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${id}/cancel`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  return response.json();
};

export const printInvoiceCourtesyCopy = async (id, token, tenant) => {
  const response = await safeFetch(`/api/invoices/${id}/courtesy-copy/print`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;

    try {
      const errorJson = await response.json();
      errorMessage = errorJson?.error || errorJson?.message || errorMessage;
    } catch {
      const text = await response.text();
      if (text) errorMessage = text;
    }

    throw new Error(errorMessage);
  }

  return response.json();
};
